const codingTable = [
  {
    A: 1, B: 0, C: 9, D: 8, E: 7, F: 6, G: 5, H: 4, I: 9, J: 3, K: 2, L: 2, M: 1,
    N: 0, O: 8, P: 9, Q: 8, R: 7, S: 6, T: 5, U: 4, V: 3, W: 1, X: 3, Y: 2, Z: 0,
  },
  { A: 0, B: 8, C: 6, D: 4, 1: 8, 2: 6, 8: 4, 9: 2 },
  { 0: 0, 1: 7, 2: 4, 3: 1, 4: 8, 5: 5, 6: 2, 7: 9, 8: 6, 9: 3 },
  { 0: 0, 1: 6, 2: 2, 3: 8, 4: 4, 5: 0, 6: 6, 7: 2, 8: 8, 9: 4 },
  { 0: 0, 1: 5, 2: 0, 3: 5, 4: 0, 5: 5, 6: 0, 7: 5, 8: 0, 9: 5 },
  { 0: 0, 1: 4, 2: 8, 3: 2, 4: 6, 5: 0, 6: 4, 7: 8, 8: 2, 9: 6 },
  { 0: 0, 1: 3, 2: 6, 3: 9, 4: 2, 5: 5, 6: 8, 7: 1, 8: 4, 9: 7 },
  { 0: 0, 1: 2, 2: 4, 3: 6, 4: 8, 5: 0, 6: 2, 7: 4, 8: 6, 9: 8 },
  { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9 },
  { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9 },
]

const checkRocIdValidation = rocId => /^[A-Z][12]\d{8}$/.test(rocId)

const checkSum = id => {
  let sum = 0
  for (let i=0; i<10; ++i)
    sum += codingTable[i][id.charAt(i)]
  return !(sum % 10)
}

export const validateTaiwanId = (rocId) => {
  if (!checkRocIdValidation(rocId)) return false
  return checkSum(rocId)
}